import React, { Component } from "react";
import { gql } from "@apollo/client";
import Modal from "react-bootstrap/Modal";
import dateFormat from "dateformat";

import { apolloClient } from "../../../index";
import { getName, getIntials } from "../../../helper";
import { notify } from "../../Notify/Notify";
import closeIcon from "../../../assets/close.svg";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import "./UserInvitationStatusModal.scss";
class UserInvitationStatusModal extends Component {
  state = {
    showInvitationModal: false,
    invitationList: [],
    roles: {"IT Admin": 1, "Admin": 2, "Manager": 3, "User": 4,"Guest": 5}
  };

  openInvitatioinDialog = () => {
    let isOpen = !this.state.showInvitationModal;
    if (isOpen) {
      this.setState({ showInvitationModal: isOpen });
    } else {
      this.handleClose();
    }
  };

  handleClose = () => {
    this.setState({ showInvitationModal: false });
  };

  getInvitationList = (e) => {
    e.preventDefault();

    apolloClient
      .query({
        query: gql`
          query userInvitation {
            userInvitation {
              id
              inviteSenderId {
                firstName
                lastName
                profile {
                  image
                  role {
                    name
                  }
                }
              }
              inviteReceiverEmail
              role {
                name
              }
              createdTs
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        this.setState(
          {
            invitationList: result.data.userInvitation,
          },
          () => this.openInvitatioinDialog()
        );
      })
      .catch((e) => {
        this.setState({ showInvitationModal: false });
        const title = "Error";
        const detail = "Something went wrong try again later!";
        const type = "error";
        notify(title, detail, type);
      });
  };

  deleteUserFromList = (receiverEmail) =>{  
      

      const variables = {
        inviteReceiverEmail: receiverEmail,
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation deleteUserInvitation($inviteReceiverEmail: String!) {
              deleteUserInvitation(
                inviteReceiverEmail: $inviteReceiverEmail
              ) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.deleteUserInvitation.success) {
            let invitationList = this.state.invitationList.filter((item)=>item.inviteReceiverEmail !== receiverEmail)
            this.setState({invitationList:invitationList})
            // Delete toaster on successfully deletion  
            const title = "Delete";
            const detail = "Invitation for " + receiverEmail + " successfully";
            const type = "success";
            notify(title, detail, type);
          }
        })
        .catch((e) => {
          //notify for an error
          const title = "Error";
          const detail = e.message;
          const type = "error";
          notify(title, detail, type);
        });
  } 

  resendUserInvitation = (receiverEmail, role) => {
    const variables = {
      email: receiverEmail,
      roleId: this.state.roles[role],
      resend: true,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation InviteSingleUser($email: String!, $roleId: Int!, $resend: Boolean!) {
            sendSingleUserInvitation(
              inviteReceiverEmail: $email
              roleId: $roleId
              resend: $resend
            ) {
              token
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.sendSingleUserInvitation.token) {
          // Add toaster on successfully invitation
          const title = "Success";
          const detail = "Invitation sent successfully";
          const type = "success";
          notify(title, detail, type);
        }
      })
      .catch((e) => {
        //notify for an error
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  }

  render() {
    return (
      <>
        <div className="ml-auto mr-4">
          <button
            className="btn-dropdown invitation-btn"
            onClick={(event) => this.getInvitationList(event)}
          >
            Users Invited
          </button>
        </div>

        <Modal
          className="feedback-modal invitation-modal"
          centered
          size="xl"
          show={this.state.showInvitationModal}
          onHide={this.handleClose}
        >
          <div className="feedback-modal-content">
            <div className="header">
              <h3 className="title">Users Invited</h3>
              <img
                className="close"
                src={closeIcon}
                alt="close"
                onClick={this.handleClose}
              />
            </div>

            <div className="body">
              {this.state.invitationList.length > 0 ? (
                <div className="table-responsive mt-4">
                  <table className="table table-hover">
                    <thead className="table-borderless">
                      <tr>
                        <th scope="col">
                          <label>Invitation Email</label>
                        </th>
                        <th scope="col">
                          <label>Invitation Role</label>
                        </th>
                        <th scope="col">
                          <label>Invitation Time</label>
                        </th>
                        <th scope="col">
                          <label>Invited By</label>
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.invitationList.map((invitation) => (
                        <tr>
                          <td>{invitation.inviteReceiverEmail}</td>
                          <td>{invitation.role.name}</td>
                          <td>
                            {dateFormat(
                              invitation.createdTs,
                              "hh:mm - mmm dd, yyyy"
                            )}
                          </td>
                          <td>
                            <ProfileWithName
                              sKey={invitation.id}
                              nameIntial={getIntials(invitation.inviteSenderId)}
                              personName={getName(invitation.inviteSenderId)}
                              profile={invitation.inviteSenderId.profile.image}
                              isPopover={true}
                              role={invitation.inviteSenderId.profile.role.name}
                            />
                          </td>
                          <td>
                            <button
                              className="btn-primary create-button"
                              onClick={(e)=>{this.resendUserInvitation(invitation.inviteReceiverEmail, invitation.role.name)}}
                            >
                              Resend
                            </button>

                            <button
                              className="btn-tertiary cancel-button ml-2"
                              onClick={(e) => this.deleteUserFromList(invitation.inviteReceiverEmail)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>No Pending Invitation</div>
              )}
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default UserInvitationStatusModal;
